<template>
  <div class="item-box-content mainStep" style="min-height:632px">
    <el-row>
      <el-col :span="12">
        <div class="title-font-style">
          <span>罚没金收票</span>
        </div>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <div v-if="state===0">
      <el-form label-width="70px" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{params.retreatNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票金额：">{{params.amount|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货类型：">{{params.bilingType}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型：">
              <el-select v-model="queryParams.retreatInvoiceVo.invoiceType" placeholder="请选择">
                <el-option
                  v-for="(item,index) in invoiceType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税率：">
              <el-select v-model="queryParams.retreatInvoiceVo.taxRate" placeholder="请选择">
                <el-option
                  v-for="(item,index) in taxRateList"
                  :key="index"
                  :label="item.taxNameex"
                  :value="item.taxCount"
                >
                  <span style="float: left">{{ item.taxName }}</span>
                  <span
                    style="float: right; color: #8492a6; font-size: 13px"
                  >{{ item.taxCount|perCentFilter }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称：">
              <div class="approval">{{params.invoiceReceiveCompany}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票编号：">
              <el-input v-model.trim="queryParams.retreatInvoiceVo.invoiceNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button @click="applyTicket" type="primary">申请收票</el-button>
      <div class="title-text">
        <span class="text-title">{{"*请携带发票交予财务部审批"}}</span>
      </div>
    </div>
    <div v-if="state !== 0">
      <el-table
        border
        ref="tableRef"
        :data="dataList"
        max-height="378"
        tooltip-effect="dark"
        style="margin-top:20px;"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="invoiceReceiveNumber" label="收票编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="invoiceReceiveCompany" label="公司名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="invoiceNumber" label="发票编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="amount" label="发票金额">
          <template slot-scope="scope">
            <div>{{ scope.row.amount | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="taxAmount" label="税额">
          <template slot-scope="scope">
            <div>{{ scope.row.taxAmount | priceFilterNum }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" label="申请时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="invoiceType" label="发票类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="bilingType" label="收票类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="state" label="收票状态">
          <template slot-scope="scope">
            <div>{{ status[scope.row.state-1] }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="processUser" label="处理人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="invoiceReceiveDate" label="收票时间"></el-table-column>
      </el-table>
      <div v-if="state===1">
        <el-steps align-center :active="2" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="收票申请" icon="el-icon-success"></el-step>
          <el-step title="收票审批" icon="el-icon-success"></el-step>
          <el-step title="收票成功" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <div v-else-if="state===2">
        <div>
          <el-steps align-center :active="3" style="margin:auto;padding:20px;margin-top:20px; ">
            <el-step title="收票申请" icon="el-icon-success"></el-step>
            <el-step title="收票审批" icon="el-icon-success"></el-step>
            <el-step title="收票成功" icon="el-icon-success"></el-step>
          </el-steps>
        </div>
        <div class="title-text">
          <span class="text-title">{{"*如方案调整需要重开发票，请自行与财务沟通票据事宜"}}</span>
        </div>
      </div>
      <div v-else>
        <el-steps align-center :active="3" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="收票申请" icon="el-icon-success"></el-step>
          <el-step title="收票审批" icon="el-icon-success"></el-step>
          <el-step title="审核失败" icon="el-icon-error"></el-step>
        </el-steps>
        <div>
          <el-form class="details-line-height" style="padding:20px 30px 0 0px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="处理人：">{{queryParams.processUsers}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="处理时间：">{{queryParams.invoiceReceiveDates}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注：">{{queryParams.mark}}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-button @click="againTicket" type="primary">重新申请</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryRetreatInvoice, queryFinanceBillTaxSettingAll, addRetreatInvoice
} from '@/api/purchase/purchasePlanList'
export default {
  components: {
  },
  data () {
    return {
      invoiceType: [
        { label: '普通发票', value: '普通发票' },
        { label: '专用发票', value: '专用发票' }
      ],
      status: ['收票审批', '收票成功', '已退票', '审核失败'],
      state: 1,
      storge: [],
      queryParams: {},
      dataList: [],
      taxRateList: []
    }
  },

  mounted () { },
  methods: {
    againTicket () {
      this.state = 0
    },
    applyTicket () {
      addRetreatInvoice(this.queryParams).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('收票审核提交成功！')
          this.getList()
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getList () {
      queryFinanceBillTaxSettingAll().then((res) => {
        if (res.data.code === 200) {
          this.taxRateList = res.data.obj.map(item => {
            item.taxNameex = item.taxName + '    ' + (item.taxCount * 100).toFixed(2) + '%'
            return item
          })
        }
      })
        .catch((err) => {
          console.log(err)
        })
      queryRetreatInvoice(this.$route.query.pcrId).then((res) => {
        if (res.data.code === 200) {
          this.queryParams = res.data.obj
          this.state = res.data.obj.invoiceState
          this.dataList = res.data.obj.retreatInvoiceDetailVoList
          this.params = res.data.obj.retreatInvoiceVo
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 500;
  color: #4e555b;
  line-height: 24px;
  padding-left: 30px;
}
.title-second {
  font-size: 16px;
  font-weight: 600;
  color: #4e555b;
  line-height: 24px;
  padding-left: 10px;
}
.title-text {
  margin: 20px 0 14px;
  .text-title {
    // margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
</style>
